import useGetPosition from '@/lib/hooks/useGetPosition';
import { motion } from 'framer-motion'
import React, { Dispatch, SetStateAction, useEffect, useMemo, useState } from 'react'


const SnappingSliderAlcohol = ({ setData, dataKey }: { setData: Dispatch<SetStateAction<Record<string, string>>>, dataKey: string }) => {
    const [rangeValue, setRangeValue] = useState(0)

    const emojiArr = ["https://storage.googleapis.com/bonatra-assets/BonatraApplicationAssets/No%20Fill%20(1).webp",
        "https://storage.googleapis.com/bonatra-assets/BonatraApplicationAssets/Two%20Fill.webp",
        "https://storage.googleapis.com/bonatra-assets/BonatraApplicationAssets/Three%20Fill.webp",
        "https://storage.googleapis.com/bonatra-assets/BonatraApplicationAssets/Four%20Fill.webp"]
    const MIN_VALUE = 0;
    const totalRange = 99.9999
    const SNAP_POINTS = 4;
    const MAX_VALUE = 100; // Adjust these values based on your needs
    const step = totalRange / (SNAP_POINTS - 1);

    const values = ["None", "Less than 4 drinks per week", "5 - 10 drinks per week", "11+ drinks per week"]
    let stepToValueMap: any = {}
    let valueToStepMap: any = {}
    for (let i = 0, j = 0; i <= 100; i += step, j += 1) {
        stepToValueMap = { ...stepToValueMap, [String(i)]: values[j] }
        valueToStepMap = { ...valueToStepMap, [values[j]]: i }
    }
    const mappedValue = values[Math.round((rangeValue - MIN_VALUE) / step)];
    const CANVAS_WIDTH = 300
    const DEFAULT_RADIUS = 10;
    const OFFSET = 40
    const CANVAS_WIDTH_WITH_OFFSET_X2 = CANVAS_WIDTH + OFFSET * 2
    const CANVAS_WIDTH_WITH_OFFSET = CANVAS_WIDTH + OFFSET
    const TRIANGLE_START_Y = 0
    const TRIANGLE_END_Y = 100
    const SLIDER_Y = TRIANGLE_END_Y + 40
    const NO_OF_PARTS = values?.length - 1;
    const point = CANVAS_WIDTH / NO_OF_PARTS
    const { position: sliderPosition, divRef: sliderRef } = useGetPosition()
    const [radius, setRadius] = useState(DEFAULT_RADIUS)
    const [cursorPosition, setCursorPosition] = useState((point + OFFSET))
    const pointStart = sliderPosition.x
    const valueToEmojiMap = {
        stressed: "😰",
        anxious: "😩",
        calm: "😌",
        relaxed: "😊"
    }
    const snappingPointsArr = useMemo(() => {
        const points: number[] = [];
        for (let i = pointStart + OFFSET, j = 0; i <= CANVAS_WIDTH + pointStart + OFFSET; i += point, j++) {
            points.push(i);
        }
        return points;
    }, [point, pointStart]);

    const valueToPointMap = useMemo(() => {
        const valuesMap = {}
        for (let i = pointStart + OFFSET, j = 0; i <= CANVAS_WIDTH + pointStart + OFFSET; i += point, j++) {
            valuesMap[i - pointStart] = values[j]
        }
        return valuesMap;
    }, [point, pointStart])

    const snappingPoint = snappingPointsArr.map(el => {
        const x = el - pointStart
        return <circle key={el} cx={x} cy={SLIDER_Y} r="4" fill="white" strokeWidth="2" opacity={1} />
    })
    const emojis = snappingPointsArr.map((el, idx) => {
        // const isSelected = valueToEmojiMap[valueToPointMap[cursorPosition]] === emojiArr[idx]
        const isSelected = mappedValue === emojiArr[idx]
        const x = idx === 0 ? el - pointStart - 20 : el - pointStart - 24
        const heightAndWidth = idx === 0 ? 40 : 50

        const y = idx === 0 ? SLIDER_Y - 74 : SLIDER_Y - 80
        return <motion.image key={el} href={emojiArr[idx]} x={x} y={y} height={heightAndWidth} width={heightAndWidth} ></motion.image>
    })

    const handleDragEnd = () => {
        setRadius(DEFAULT_RADIUS)
    }

    const handleDrag = (event, info) => {
        const currentMousePoint = info.point.x - pointStart;
        const closestSnapIndex = snappingPointsArr.reduce((closestIndex, point, currentIndex) => {
            const pointWithoutOffset = point - pointStart;
            const closestWithoutOffset = snappingPointsArr[closestIndex] - pointStart;
            const distance = Math.abs(currentMousePoint - pointWithoutOffset);
            const distanceToClosest = Math.abs(currentMousePoint - closestWithoutOffset);
            return distance < distanceToClosest ? currentIndex : closestIndex;
        }, 0);
        const closestSnapPoint = snappingPointsArr[closestSnapIndex] - pointStart;
        setRadius(DEFAULT_RADIUS * 1.2)
        setData(p => {
            localStorage.setItem('bioFormData', JSON.stringify({ ...p, [dataKey]: valueToPointMap[closestSnapPoint] }));
            return { ...p, [dataKey]: valueToPointMap[closestSnapPoint] }
        })
        setCursorPosition(closestSnapPoint)
    };
    const handleClick = (event) => {
        const clickX = event.clientX - pointStart;
        const closestSnapIndex = snappingPointsArr.reduce((closestIndex, point, currentIndex) => {
            const pointWithoutOffset = point - pointStart;
            const closestWithoutOffset = snappingPointsArr[closestIndex] - pointStart;
            const distance = Math.abs(clickX - pointWithoutOffset);
            const distanceToClosest = Math.abs(clickX - closestWithoutOffset);
            return distance < distanceToClosest ? currentIndex : closestIndex;
        }, 0);

        const closestSnapPoint = snappingPointsArr[closestSnapIndex] - pointStart;
        setData(p => {
            localStorage.setItem('bioFormData', JSON.stringify({ ...p, [dataKey]: valueToPointMap[closestSnapPoint] }));
            return { ...p, [dataKey]: valueToPointMap[closestSnapPoint] }
        })
        setCursorPosition(closestSnapPoint);
    };

    useEffect(() => {
        const storedData = localStorage.getItem('bioFormData');

        if (storedData) {
            const parsed = JSON.parse(storedData)
            const newValue = parsed?.[dataKey]
            if (newValue) {
                setData(p => {
                    return { ...p, [dataKey]: newValue }
                })
                setRangeValue(valueToStepMap[newValue])
            } else {
                setData(p => {
                    return { ...p, [dataKey]: "Less than 4 drinks per week" }
                })
            }
        }

    }, [])



    const handleRangeSlider = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = parseFloat(e.target.value);
        setRangeValue(newValue)
        setData(p => {
            localStorage.setItem('bioFormData', JSON.stringify({ ...p, [dataKey]: stepToValueMap[newValue] }));
            return { ...p, [dataKey]: stepToValueMap[newValue] }
        })
    }
    return (
        <motion.div ref={sliderRef} className=" " animate={{ y: -60 }}>
            <motion.svg width={CANVAS_WIDTH_WITH_OFFSET_X2} height="120" style={{ cursor: "pointer" }} onClick={handleClick}
            >
                <defs>
                    <mask id="triangleMask" x="0" y="0" width="100%" height="100%">
                        <polygon points={`${OFFSET} ${TRIANGLE_END_Y} ${CANVAS_WIDTH_WITH_OFFSET} ${TRIANGLE_END_Y} ${CANVAS_WIDTH_WITH_OFFSET} ${TRIANGLE_START_Y}`} fill="#ffffff" opacity={1} />
                    </mask>
                </defs>
                {/* <rect fill="url(#gradientId)" rx={4} ry={4} x={OFFSET} y={SLIDER_Y - 2} width={CANVAS_WIDTH} height="4" opacity={0.2} /> */}
                <defs>
                    <linearGradient id={"gradientId"} x1="0%" y1="0%" x2="100%" y2="10%">
                        <stop offset="0%" style={{ stopColor: '#00ff00' }} />
                        <stop offset="50%" style={{ stopColor: '#ffd222' }} />
                        <stop offset="100%" style={{ stopColor: '#ff9999' }} />
                    </linearGradient>
                </defs>
                {emojis}
                <mask id="gradientBarMask" x="0" y="0" width="100%" height="100%">
                    {/* <rect fill="white" rx={4} x={OFFSET} y={SLIDER_Y - 2} width={cursorPosition - OFFSET + 1} height="4" /> */}
                    <g>
                        {snappingPoint}
                    </g>
                </mask>
                {/* <rect fill="url(#gradientId)" rx={4} ry={4} mask='url(#gradientBarMask)' x={0} y={0} width={CANVAS_WIDTH_WITH_OFFSET_X2} height="200" /> */}
                {/* <motion.g
                    whileHover={{ cursor: "pointer" }}
                    drag='x'
                    dragConstraints={{ left: 0, right: 0 }}
                    dragElastic={false}
                    dragMomentum={false}
                    onDrag={handleDrag}
                    onDragEnd={handleDragEnd}
                    dragTransition={{ bounceStiffness: 0, bounceDamping: 0 }}
                >
                    <motion.circle cx={cursorPosition} cy={SLIDER_Y} r={radius} fill="#666" opacity={1} stroke="white" strokeWidth="2" />
                    <motion.circle
                        cx={cursorPosition} cy={SLIDER_Y} r="4" fill="#fff" stroke="white" strokeWidth="2" />
                </motion.g> */}
            </motion.svg>
            <div className='translate-y-[20px]'>
                <div className='relative flex justify-center'>
                    <input type={"range"} title="range" value={rangeValue} style={{ width: CANVAS_WIDTH_WITH_OFFSET - 28 }} className="appearance-none bg-transparent  [&::-webkit-slider-runnable-track]:rounded-full [&::-webkit-slider-runnable-track]:h-4  [&::-webkit-slider-runnable-track]:bg-gradient-to-r from-red-100 to-red-100  [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:h-[20px] [&::-webkit-slider-thumb]:w-[20px] [&::-webkit-slider-thumb]:-translate-y-[3px] [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-red-400" onChange={handleRangeSlider} step={step}
                    />
                </div>
                <motion.div className='px-2 select-none' initial={{ textAlign: "center", userSelect: 'none', fontWeight: "bold", y: 10, borderRadius: 10, color: "#222", }} animate={{ x: 0, }} >{mappedValue}</motion.div>
            </div>
        </motion.div>
    )
}

export default SnappingSliderAlcohol

